/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { productService } from 'services'

const initialState = {
  banners: [],
  isLoading: true,
}

const { getBanners } = productService()

export const fetchBanners = createAsyncThunk('banners/getBanners', async contractId => {
  try {
    const { data } = await getBanners(contractId)
    return data
  } catch (error) {
    console.error(error)
    return []
  }
})

export const bannerSlice = createSlice({
  name: 'banners',
  initialState,
  extraReducers: builder => {
    builder
      .addCase(fetchBanners.pending, state => {
        state.isLoading = true
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.banners = action.payload
        state.isLoading = false
      })
      .addCase(fetchBanners.rejected, state => {
        state.banners = []
        state.isLoading = false
      })
  },
})

export default bannerSlice.reducer
